export default __webpack_public_path__ + "static/media/jbl-c100si-in-person.5eb978a6.png";